import { createRouter, createWebHistory } from "vue-router"; // 👈 Use factory functions

const routes = [
  {
    path: "/",
    name: "Home",
    component: () => import(/* webpackChunkName: "versions" */ "../views/Home.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/versions",
    name: "Versions",
    component: () => import(/* webpackChunkName: "versions" */ "../views/Versions.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/jobs",
    name: "Jobs",
    component: () => import(/* webpackChunkName: "jobs" */ "../views/Jobs.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/logs",
    name: "Logs",
    component: () => import(/* webpackChunkName: "logs" */ "../views/Logs.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/customers",
    name: "Customers",
    component: () => import(/* webpackChunkName: "customers" */ "../views/Customers.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/customers/:customerId",
    name: "Customer",
    props: true,
    component: () => import(/* webpackChunkName: "customer" */ "../views/Customer.vue"),
    meta: { requiresAuth: true }
  },
  {
    path: "/login",
    name: "Login",
    component: () => import(/* webpackChunkName: "customers" */ "../views/Login.vue")
  },
  {
    path: "/billing",
    name: "Billing",
    component: () => import(/* webpackChunkName: "biling" */ "../views/Billing.vue"),
    meta: { requiresAuth: true }
  },
  {
    // 👈 Vue 3 catch-all routes require a parameter with a custom regex
    path: "/:pathMatch(.*)*", 
    name: "NotFound",
    component: () => import(/* webpackChunkName: "customers" */ "../views/NotFound.vue"),
    meta: { requiresAuth: true }
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL), // 👈 Replaces mode: "history"
  routes
});

router.beforeEach((to, from, next) => {
  var session = JSON.parse(localStorage.getItem("session"));
  const loggedIn = !!(session != null && session.id);
  if (to.matched.some(record => record.meta.requiresAuth) && !loggedIn) {
    next("/login");
  } else {
    next();
  }
});

export default router;
